import {
    GET_LIST_APPOINTMENTS,
    GET_APPOINTMENT_LIST_BY_CUSTOMER,
    GET_APPOINTMENTS_STATISTICS,
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0, // total records
            perPage: 50,
        },
    },
    statistics: {},
    appointmentsByCustomer: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_APPOINTMENTS: {
            return {
                ...state,
                list: {
                    data: action.payload?.list?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload?.list?.current_page, 10) || 1,
                        total: parseInt(action.payload?.list?.total, 10) || 0,
                        perPage: parseInt(action.payload?.list?.per_page, 10) || state.list.pagination.perPage,
                    },
                }
            };
        }

        case GET_APPOINTMENT_LIST_BY_CUSTOMER: {
            return {
                ...state,
                appointmentsByCustomer: action.payload || [],
            };
        }

        case GET_APPOINTMENTS_STATISTICS: {
            return {
                ...state,
                statistics: action.payload || {},
            };
        }

        default:
            return { ...state };
    }
};